// extracted by mini-css-extract-plugin
export var divider = "_ps-0";
export var systemMessage = "_ps-1";
export var systemMessageWrapper = "_ps-2";